import { camelCase } from './lib/utils';

import * as stories from './micromags/index';
import { MicromagItem } from './types/micromag';

import items from './micromags.json';

const micromags: MicromagItem[] = items.map((item) => {
    return {
        ...item,
        story: stories[camelCase(item.slug)] || null,
    };
});

export default micromags;
